import React from 'react';
import { Switch } from 'react-router-dom';

const ServicesRouter: React.FunctionComponent = () => {
    return  <Switch>
    {/* <Route path={`${ROUTES.CMS_UPLOAD}/:cmsid`} component={CMSUpload} /> */}
  </Switch>
}

export default ServicesRouter